import { ReactNode, useMemo } from 'react'
import { ILinkContext, LinkContext } from '@intersport-digital/react'
import LinkWrapper from '#app/components/LinkWrapper.tsx'

export default function LinkProvider({ children }: { children: ReactNode }) {
	const CustomLinkContext: ILinkContext = useMemo(
		() => ({ wrapper: LinkWrapper }),
		[],
	)

	return (
		<LinkContext.Provider value={CustomLinkContext}>
			{children}
		</LinkContext.Provider>
	)
}
